import React, { useState } from "react";
import { checkArray, checkNull } from "../../helpers";
import MultiRangeSlider from "./MultiRangeSlider";

const FilterContainer = ({
  inputs = [],
  submitHandler,
  filterMin,
  filterMax,
  filterSymbol,
  filterOnChange,
}) => {
  const getInputsContainer = () => {
    let res = null;
    if (checkArray(inputs)) {
      res = inputs.map((inpt, inptInx) => {
        return (
          <div class="select-div col px-1">
            <div class="input select">
              <select
                class="csutom_select"
                name={`${inpt?.name}`}
                id={`${inpt?.name}_${inptInx}`}
                value={inpt?.value}
                onChange={(e) => inpt?.onChange(inpt?.name, e?.target?.value)}
              >
                <option value="">{inpt?.empty}</option>
                {checkNull(inpt?.options, false) && inpt?.options}
              </select>
            </div>{" "}
          </div>
        );
      });
    }
    return res;
  };
  return (
    <div class="row mx-0">
      <div class="shadowclass top_filters orderpayy align-items-end">
        <h4 class="event-alert py-0 my-2">Filters </h4>
        <div className="row mx-0">
          <div class="col-lg-9 selecters pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0 px-0 extend-filters">
            {getInputsContainer()}
          </div>
          <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0 mt-md-3 mt-0 mt-lg-0 px-sm-2">
            <MultiRangeSlider
              min={filterMin}
              max={filterMax}
              symbol={filterSymbol}
              onChange={({ min, max }) => {
                console.log(`min = ${min}, max = ${max}`);
                filterOnChange({ min, max });
              }}
            />
          </div>
          <div class="col-lg-1 col px-0 px-xl-3 px-sm-1 pt-3 pt-lg-0">
            <button
              class="btn btn_btnblue"
              type="button"
              onClick={() => {
                submitHandler();
              }}
            >
              Search
            </button>
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default FilterContainer;
